import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/free-solid-svg-icons'
import React from 'react'
import { StyledIcon } from './index'

export const DownloadIcon = ({
  height,
  width,
  fontSize,
  color,
}: {
  height?: number
  width?: number
  fontSize?: number
  color?: string
}): JSX.Element => (
  <StyledIcon height={height} width={width} fontSize={fontSize} color={color}>
    <FontAwesomeIcon icon={faDownload} />
  </StyledIcon>
)
